import "./Header.scss";
import SearchFilter from "../SearchFilter/SearchFilter";

const Header = () => {
  return (
    <header className="header">
      <SearchFilter />
    </header>
  );
};
export default Header;
